// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.savedreply.SatelliteWebLandlordSavedReplyHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  SatelliteWebLandlordSavedReplyAddSavedRepliesRequestDto,
  SatelliteWebLandlordSavedReplyDeleteSavedRepliesRequestDto,
  SatelliteWebLandlordSavedReplyEditSavedReplyRequestDto,
  SatelliteWebLandlordSavedReplyGetSavedRepliesResponseDto,
} from '../..';

export const SatelliteWebLandlordSavedReplyHandler_addSavedReplies_Path =
  '/api/web/landlord/v1/savedReply/addSavedReplies';

/**
 * Add saved replies
 */
export const SatelliteWebLandlordSavedReplyHandler_addSavedReplies = (
  postData: SatelliteWebLandlordSavedReplyAddSavedRepliesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebLandlordSavedReplyAddSavedRepliesRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordSavedReplyHandler_addSavedReplies_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordSavedReplyHandler_deleteSavedReplies_Path =
  '/api/web/landlord/v1/savedReply/deleteSavedReplies';

/**
 * Delete saved replies
 */
export const SatelliteWebLandlordSavedReplyHandler_deleteSavedReplies = (
  postData: SatelliteWebLandlordSavedReplyDeleteSavedRepliesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebLandlordSavedReplyDeleteSavedRepliesRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordSavedReplyHandler_deleteSavedReplies_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordSavedReplyHandler_editSavedReply_Path =
  '/api/web/landlord/v1/savedReply/editSavedReply';

/**
 * Edit a saved reply
 */
export const SatelliteWebLandlordSavedReplyHandler_editSavedReply = (
  postData: SatelliteWebLandlordSavedReplyEditSavedReplyRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebLandlordSavedReplyEditSavedReplyRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordSavedReplyHandler_editSavedReply_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordSavedReplyHandler_getSavedReplies_Path =
  '/api/web/landlord/v1/savedReply/getSavedReplies';

/**
 * Get saved replies
 */
export const SatelliteWebLandlordSavedReplyHandler_getSavedReplies = (client = getClient()) => {
  return httpFrontEndRequest<never, never, SatelliteWebLandlordSavedReplyGetSavedRepliesResponseDto>(
    {
      endpoint: SatelliteWebLandlordSavedReplyHandler_getSavedReplies_Path,
      method: 'GET',
      contextPath: '/satellite',
    },
    client,
  );
};
